import PropTypes from "prop-types";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const InsurancePlanCoverage = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) ?? INITIAL_VALUES.skip,
    take: parseInt(filter.take) ?? INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.INSURANCE_PLAN_COVERAGES, {
    variables,
  });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "insurancePlanCoverages",
      }}
    />
  );
};

InsurancePlanCoverage.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

InsurancePlanCoverage.defaultProps = {
  filter: {},
};

export default InsurancePlanCoverage;
